// Turn a Supabase/Postgres error into something a person can read.
//
// Ported from Shadowland Title alongside the canvas. Kept out of
// lib/supabase.js so the canvas can use it without that module growing a
// second responsibility: lib/supabase.js is the client, this is how its
// failures are phrased.
export function errorMessage(error, fallback = 'Something went wrong') {
  if (!error) return fallback;
  const raw = error.message || error.error_description || error.details || '';
  if (!raw) return fallback;
  if (raw.includes('violates row-level security')) {
    return 'You do not have access to that.';
  }
  if (raw.includes('duplicate key')) {
    return 'That already exists.';
  }
  // Postgres raises our own guard messages verbatim; those are already
  // written for a person to read.
  return raw.replace(/^new row violates.*$/i, 'You do not have access to that.');
}
